/**
 * Cart Quantity Select — dropdown quantity selector for cart drawer cards.
 *
 * Wraps a native <select> (hidden via opacity: 0) and a visible
 * .custom-select display span. The native select handles interaction,
 * and the custom span mirrors the selected value for full styling control.
 *
 * Wires the change event into the existing CartItems / CartDrawerItems
 * updateQuantity flow. The change event is stopped from propagating so
 * CartItems.validateQuantity (which expects an <input type="number">
 * with .step / .max properties) is never called.
 */

if (!customElements.get('cart-qty-select')) {
  customElements.define(
    'cart-qty-select',
    class CartQtySelect extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.display = this.querySelector('.custom-select');
        if (!this.select) return;
        this.handleChange = this.handleChange.bind(this);
        this.select.addEventListener('change', this.handleChange);
      }

      disconnectedCallback() {
        this.select?.removeEventListener('change', this.handleChange);
      }

      handleChange(event) {
        event.stopPropagation();

        const quantity = parseInt(this.select.value, 10);
        const { index, quantityVariantId } = this.select.dataset;

        if (this.display) {
          const selected = this.select.options[this.select.selectedIndex];
          this.display.textContent = selected.textContent;
        }

        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        if (!cartItems) return;

        cartItems.updateQuantity(index, quantity, event, this.select.name, quantityVariantId);
      }
    }
  );
}
